import { render, staticRenderFns } from "./FormPersona.vue?vue&type=template&id=3e06b880&scoped=true&lang=pug"
import script from "./FormPersona.vue?vue&type=script&lang=js"
export * from "./FormPersona.vue?vue&type=script&lang=js"
import style0 from "./FormPersona.vue?vue&type=style&index=0&id=3e06b880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06b880",
  null
  
)

export default component.exports